import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HTTPRequestMethod } from 'lib-shared-legacy-types';
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { findScopeVariableMatches } from 'components/powerFlowShared/helpers/findScopeVariableMatches';
import { flowNodeColor, FlowType } from 'fable/flowEditor';
import { hexStringToNumber } from 'fable/flowEditor/components/flowManager/canvas/renderers/common/colors';
import { Text } from 'flow-builder/node/text';
import { TextBreak } from 'flow-builder/node/textBreak';
import { TextContent } from 'flow-builder/node/textContent';
import IntegrationModal from '../../../containers/modals/integration';
const translatePayload = (node) => {
    const { nextNodeId } = node.payload;
    return [
        {
            id: uuid(),
            label: 'arrow',
            connection: nextNodeId || uuid(),
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { nextNodeId: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
const translateScopeVariables = (node) => {
    const { variables = [], url, body } = node.payload;
    const needs = [
        ...findScopeVariableMatches(url),
        ...findScopeVariableMatches(body),
    ];
    const grants = variables.reduce((acc, { id }) => {
        if (id) {
            acc.push(id);
        }
        return acc;
    }, []);
    return {
        needs,
        grants,
    };
};
const integrationDefaultHelpText = 'Integrate third-party systems or your own API to route conversations based on relevant customer information in Dixa (e.g. previous orders, tracking links, etc.).';
const createIntegrationNode = (flowType, attributes) => {
    var _a;
    return ({
        iconName: 'bolt',
        label: 'Integration',
        color: hexStringToNumber(flowNodeColor.blue),
        helpText: (_a = attributes === null || attributes === void 0 ? void 0 : attributes.helpText) !== null && _a !== void 0 ? _a : integrationDefaultHelpText,
        translateScopeVariables,
        translatePayload,
        updateConnection,
        NodeContent: IntegrationNode,
        ActionModal: IntegrationModal(flowType),
    });
};
export const IntegrationNodePhoneAttributes = createIntegrationNode(FlowType.FLOW_TYPE_CALL);
export const IntegrationNodeEmailAttributes = createIntegrationNode(FlowType.FLOW_TYPE_EMAIL);
export const IntegrationNodeMessengerAttributes = createIntegrationNode(FlowType.FLOW_TYPE_MESSENGER);
export function IntegrationNode({ node, scopeVars, }) {
    const { grants } = scopeVars;
    const { payload } = node;
    const { httpRequestType = HTTPRequestMethod.Get } = payload;
    return (_jsx(TextContent, { children: useMemo(() => (_jsx(_Fragment, { children: _jsxs(TextBreak, { children: [_jsx(Text, { weight: "normal", text: "Method" }), _jsx(Text, { weight: "semibold", text: `${httpRequestType}${grants.length > 0 ? ',' : ''}` }), grants.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Text, { weight: "normal", text: grants.length === 1 ? 'Variable' : 'Variables' }), _jsx(Text, { weight: "semibold", text: grants.join(', ') })] }))] }) })), [httpRequestType, grants]) }));
}
